// extracted by mini-css-extract-plugin
module.exports = {"scimSubTextColor":"#505363","scimColorPrimary":"#00b259","scimColorBkF2":"#f2f2f5","sideBarWidth":"224px","scimRableBlockColor":"#f5f7fa"};